export function isElementOverflowing(element: HTMLElement, container: HTMLElement): boolean {
  const { top: elementTop, bottom: elementBottom } = element.getBoundingClientRect();
  const { top: containerTop, bottom: containerBottom } = container.getBoundingClientRect();

  return elementTop < containerTop || elementBottom > containerBottom;
}

export function scrollElementIntoViewIfNeeded(element: HTMLElement, container: HTMLElement): void {
  if (!isElementOverflowing(element, container)) {
    return;
  }

  element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
}
